module.exports = __webpack_public_path__ + "img/huatairenshou.65b51c74.png";